import { AxiosInstance } from 'axios';
import { get, post, patch } from '../hooks/useAxiosPrivate';
import {
  WifiNetworkEntity,
  PushWifiNetworkResult,
} from '../state/wifiNetworks/types';

const companyWifiNetworksUrl = (companyId: string) =>
  `/api/v1/company/${companyId}/wifi-networks`;

const WifiNetworksApi = {
  getWifiNetworks: async (
    axios: AxiosInstance,
    companyId: string,
    params?: { search?: string }
  ): Promise<{ entities: WifiNetworkEntity[]; totalPages: number }> => {
    const response = await get(
      axios,
      companyWifiNetworksUrl(companyId),
      params
    );
    return response.data;
  },
  createWifiNetwork: async (
    axios: AxiosInstance,
    network: { ssid: string; password: string; label?: string },
    companyId: string
  ): Promise<WifiNetworkEntity> => {
    const response = await post(
      axios,
      companyWifiNetworksUrl(companyId),
      network
    );
    return response.data;
  },
  updateWifiNetwork: async (
    axios: AxiosInstance,
    networkId: string,
    // An empty/omitted password keeps the stored one; label null clears it.
    network: { ssid?: string; password?: string; label?: string | null },
    companyId: string
  ): Promise<WifiNetworkEntity> => {
    const response = await patch(
      axios,
      `${companyWifiNetworksUrl(companyId)}/${networkId}`,
      network
    );
    return response.data;
  },
  archiveWifiNetwork: async (
    axios: AxiosInstance,
    networkId: string,
    companyId: string
  ): Promise<void> => {
    await post(
      axios,
      `${companyWifiNetworksUrl(companyId)}/${networkId}/archive`,
      {}
    );
  },
  pushWifiNetwork: async (
    axios: AxiosInstance,
    push: {
      deviceIds: string[];
      wifiNetworkId?: string;
      newNetwork?: {
        ssid: string;
        password: string;
        label?: string;
        save?: boolean;
      };
    },
    companyId: string
  ): Promise<PushWifiNetworkResult> => {
    const response = await post(
      axios,
      `${companyWifiNetworksUrl(companyId)}/push`,
      push
    );
    return response.data;
  },
};

export default WifiNetworksApi;
